import { getMinimalSupabase } from './supabase-minimal'

export async function getSupabase() {
  // Always use the minimal implementation to avoid SDK issues
  return getMinimalSupabase()
}

// Helper functions that use the lazy-loaded client
export async function signIn(email: string, password: string) {
  const supabase = await getSupabase()
  if (!supabase) {
    return { data: null, error: new Error('Supabase not available') }
  }
  return supabase.auth.signInWithPassword({ email, password })
}

export async function signOut() {
  const supabase = await getSupabase()
  if (!supabase) {
    return { error: new Error('Supabase not available') }
  }
  return supabase.auth.signOut()
}

export async function getSession() {
  const supabase = await getSupabase()
  if (!supabase) {
    return { data: { session: null }, error: null }
  }
  return supabase.auth.getSession()
}

export async function onAuthStateChange(callback: (event: any, session: any) => void) {
  const supabase = await getSupabase()
  if (!supabase) {
    return { data: { subscription: { unsubscribe: () => {} } } }
  }
  return supabase.auth.onAuthStateChange(callback)
}